import {
  Box,
  Card,
  Fade,
  Slide,
  Stack,
  Typography,
  Grow,
  useMediaQuery,
  Modal
} from '@mui/material';
import { Icon } from '@iconify/react';
import Reacts, { useState, useEffect } from 'react';
import checkmarkFill from '@iconify/icons-eva/checkmark-fill';
import plusFill from '@iconify/icons-eva/plus-fill';
import hardDriveFilled from '@iconify/icons-eva/hard-drive-fill';
import fileTextFill from '@iconify/icons-eva/file-text-fill';
import safetyCertificate from '@iconify/icons-ant-design/safety-certificate';
import emailFilled from '@iconify/icons-eva/email-fill';
import cloudDownloadOutline from '@iconify/icons-eva/cloud-download-outline';
import globeOutline from '@iconify/icons-eva/globe-outline';
import { useTheme, styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import * as Scroll from 'react-scroll';
import shuffleFill from '@iconify/icons-eva/shuffle-fill';
import wifiFill from '@iconify/icons-eva/wifi-fill';
import infoFill from '@iconify/icons-eva/info-fill';
import pcl from '@iconify/icons-eva/phone-call-fill';
import shieldFill from '@iconify/icons-eva/shield-fill';
import radioFill from '@iconify/icons-eva/radio-fill';
import tvFill from '@iconify/icons-eva/tv-fill';
import questionFill from '@iconify/icons-eva/question-mark-circle-fill';
import bookOpenFill from '@iconify/icons-eva/book-open-fill';
import recordingOutline from '@iconify/icons-eva/recording-outline';
import globe2Outline from '@iconify/icons-eva/globe-2-outline';
import videoFill from '@iconify/icons-eva/video-fill';
import filmFill from '@iconify/icons-eva/film-fill';
import videoOutline from '@iconify/icons-eva/video-outline';
//
import useWidth from '../../hooks/useWidth';

const { Link } = Scroll;

const LayananCard = styled(Card)`
  width: 100px,
  height: 100px
`;

export default function LandingBody() {
  const theme = useTheme();
  const width = useWidth(useTheme, useMediaQuery);

  const dataLayanan = [
    {
      id: 'rekomendasi',
      label: 'Rekomendasi',
      type: 'div'
    },
    {
      id: 'subdomain',
      label: 'Subdomain',
      type: 'div'
    },
    {
      id: 'hosting',
      label: 'Hosting',
      type: 'div'
    },
    {
      id: 'email',
      label: 'Email',
      type: 'div'
    },
    {
      id: 'tte',
      label: 'TTE',
      type: 'div'
    },
    {
      id: 'cloudstorage',
      label: 'Cloud Storage',
      type: 'div'
    },
    {
      id: 'splp',
      label: ' SPLP',
      type: 'modal',
      content: 'Sistem Penghubung Layanan Pemerintahan'
    },
    {
      id: 'idmc',
      label: 'Informasi Eksekutif',
      type: 'link',
      content: 'https://idmc.jogjaprov.go.id'
    },
    {
      id: 'ppid',
      label: 'PPID',
      type: 'link',
      content: 'https://ppid.jogjaprov.go.id/'
    },
    {
      id: 'ljk',
      label: 'Sandi dan Telepon',
      type: 'modal',
      content: 'Layanan Jaring Komunikasi'
    },
    {
      id: 'lki',
      label: 'Keamanan Informasi',
      type: 'link',
      content: 'https://csirt.jogjaprov.go.id/'
    },
    {
      id: 'h-lti-1',
      label: 'Jaringan Internet',
      type: 'modal',
      content: 'Layanan Pemasangan Jaringan Intra Pemerintah'
    },
    {
      id: 'mam',
      label: 'Konten Multimedia',
      type: 'link',
      content: 'https://mam.jogjaprov.go.id/'
    },
    {
      id: 'vpn',
      label: 'VPN',
      type: 'modal',
      content: 'Layanan Jaringan VPN'
    },
    {
      id: 'wifi',
      label: 'Wifi Publik',
      type: 'modal',
      content: 'Layanan Wifi Publik'
    },
    {
      id: 'ipk',
      label: 'IP Publik',
      type: 'modal',
      content: 'Layanan IP Publik'
    },
    {
      id: 'h-tik',
      label: 'Helpdesk TIK',
      type: 'modal',
      content: 'Layanan helpdesk TIK'
    },
    {
      id: 'zoom',
      label: 'Zoom',
      type: 'modal',
      content: 'Layanan Aplikasi Zoom'
    },
    {
      id: 'v-tron',
      label: 'Videotron',
      type: 'modal',
      content: 'Layanan Videotron'
    },
    {
      id: 'jitv',
      label: 'Liputan JI TV',
      type: 'link',
      content: 'https://jitv.jogjaprov.go.id/'
    }
  ];

  const getIcon = (type) => {
    if (type === 'subdomain') return globeOutline;
    if (type === 'hosting') return hardDriveFilled;
    if (type === 'tte') return safetyCertificate;
    if (type === 'email') return emailFilled;
    if (type === 'rekomendasi') return fileTextFill;
    if (type === 'cloudstorage') return cloudDownloadOutline;
    if (type === 'splp') return shuffleFill;
    if (type === 'idmc') return infoFill;
    if (type === 'wifi') return wifiFill;
    if (type === 'ljk') return pcl;
    if (type === 'lki') return shieldFill;
    if (type === 'h-lti-1') return radioFill;
    if (type === 'mam') return filmFill;
    if (type === 'h-tik') return questionFill;
    if (type === 'ppid') return bookOpenFill;
    if (type === 'vpn') return recordingOutline;
    if (type === 'ipk') return globe2Outline;
    if (type === 'zoom') return videoFill;
    if (type === 'v-tron') return tvFill;
    if (type === 'jitv') return videoOutline;
    return globeOutline;
  };

  const TransitionDiv = styled('div')`
    ${({ theme }) => `
  cursor: pointer;
  transition: ${theme.transitions.create(['background-color', 'transform'], {
    duration: theme.transitions.duration.standard
  })};
  `}
  `;

  const openLink = (link) => {
    if (!link || link === '#') return;
    window.open(link, '_blank');
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4
  };

  const [open, setOpen] = Reacts.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  function ModalDialog() {
    return (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Text in a modal
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Description in a modal
          </Typography>
        </Box>
      </Modal>
    );
  }

  function IconLayanan({ id, label, index, types, content }) {
    const navigate = useNavigate();
    return (
      <Grow in="true" timeout={1000 * index}>
        <TransitionDiv>
          <Link
            to={id}
            spy="true"
            smooth="true"
            duration={500}
            className="some-class"
            activeClass="some-active-class"
          >
            <Stack
              component={Card}
              to={id}
              spacing={2}
              p={1}
              m={1}
              onClick={types === 'link' ? () => openLink(content) : null}
              direction="column"
              alignItems="center"
              justifyContent="center"
              sx={{
                width: ['xs'].includes(width) ? 120 : 140,
                height: ['xs'].includes(width) ? 120 : 140,
                transition: theme.transitions.create(['background-color', 'transform'], {
                  duration: theme.transitions.duration.standard
                }),
                cursor: 'pointer',
                '&:hover': {
                  transform: 'scale(1.1)'
                }
              }}
            >
              <Typography variant="subtitle2" sx={{ textAlign: 'center' }}>
                {label}
              </Typography>
              <Icon
                style={{ boxShadow: 10, color: theme.palette.primary.main, fontWeight: 'bold' }}
                icon={getIcon(id)}
                width={35}
                height={35}
              />
            </Stack>
          </Link>
        </TransitionDiv>
      </Grow>
    );
  }

  return (
    <Stack
      mt={1}
      direction={{ xs: 'column', sm: 'column', md: 'column', lg: 'row' }}
      spacing={{ xs: 4, sm: 4, md: 6, lg: 6 }}
      p={{ xs: 2, sm: 4, md: 6, lg: 6 }}
      mx={{ xs: 2, sm: 4, md: 6, lg: 6 }}
      alignItems="center"
      justifyContent="center"
    >
      <ModalDialog />
      <Fade in="true">
        <Stack
          direction="row"
          flexWrap="wrap"
          alignItems="center"
          justifyContent="center"
          sx={{ flex: { md: 6, lg: 6 } }}
        >
          {dataLayanan.map((item, index) => (
            <IconLayanan
              key={item.id}
              id={item.id}
              index={index}
              label={item.label}
              types={item.type}
              content={item.content}
            />
          ))}
        </Stack>
      </Fade>
      <Slide direction="up" in="true" mountOnEnter unmountOnExit timeout={1000}>
        <Stack direction="column" alignItems="center" justifyContent="center" sx={{ flex: 6 }}>
          <img
            style={{ width: ['sm', 'md'].includes(width) ? '50%' : '100%' }}
            src="/static/illustrations/undraw_pair_programming_re_or4x.svg"
            alt="Illustration"
          />
        </Stack>
      </Slide>
    </Stack>
  );
}
